import React, { type ReactNode } from 'react';
import { HelperMessage, ErrorMessage, ValidMessage } from '@atlaskit/form';

export type ValidationMessageType = 'HELPER' | 'ERROR' | 'VALID';

type Props = {
	children: ReactNode;
	type: ValidationMessageType;
	testId?: string;
};

const ValidationMessage = ({ children, testId, type }: Props) => {
	switch (type) {
		case 'HELPER':
			return <HelperMessage testId={testId}>{children}</HelperMessage>;
		case 'VALID':
			return <ValidMessage testId={testId}>{children}</ValidMessage>;
		case 'ERROR':
			return <ErrorMessage testId={testId}>{children}</ErrorMessage>;
		default:
			// prettier-ignore
			// prettier-ignore
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(type as never);
			throw new Error('Unhandled validation message type');
	}
};

export default ValidationMessage;
